import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ObservationScores from '../components/ObservationScores';
import { fetchObservations, scoreObservation } from '../actions/observations';

let mapStateToProps = function(state) {
	return {
		isFetchingObservations: state.observations.isFetching,
		isScoringObservation: state.observations.isScoring,
		observations: state.observations.list,
		reliabilityScores: state.observations.reliabilityScores
	};
};

let mapDispatchToProps = {
	fetchObservations,
	scoreObservation
};

module.exports = connect(mapStateToProps, mapDispatchToProps)(ObservationScores);



// WEBPACK FOOTER //
// ./frontend/olos/js/containers/ObservationScores.jsx